import React from "react";
import moment from "moment";
import { withTranslation } from "react-i18next";
import DateInput from "../../../../parts/inputs/date-input";
import { ReportsBackHandler } from "../components/ReportsBackHandler";
import ButtonSwitch from "../../../../parts/buttonSwitch";
import SvgIcon from "../../../../parts/SvgIcon";
import { RillContext } from "../../../../rill/RillReact/share/base";

const dateFormat = {
  normal: "YYYY-MM-DD",
  calendar: "MMM D, YYYY",
  utc: "YYYYMMDD",
};

class RangeContainerComponent extends React.Component {
  constructor(props, ctx) {
    super(props, ctx);
  }

  renderRangeSelector() {
    const {
      dateTo,
      rangeSelector,
      quickDisabled,
      updateState,
      getDateFirstEntry,
      t,
    } = this.props;
    const { value, type } = rangeSelector;
    const Selector = ({
      text = "",
      type,
      value,
      active = false,
      getDateFirstEntry,
    }) => (
      <button
        // className={`selector ${active ? "active" : ""}`}
        data-button-type={active ? "primary" : "secondary"}
        onClick={() => {
          if (type === "lifetime") {
            updateState({
              rangeSelector: {
                type,
                value,
              },
              quickDisabled: false,
              dateTo: null,
              dateFrom: moment(getDateFirstEntry(), dateFormat.utc).format(
                dateFormat.calendar
              ),
            });
            return;
          }
          const formatedDateTo = (
            dateTo
              ? moment(dateTo, dateFormat.calendar)
              : moment(new Date(), dateFormat.normal)
          )
            .subtract(value, type)
            .format(dateFormat.calendar);

          updateState({
            dateFrom: formatedDateTo,
            dateTo,
            quickDisabled: false,
            rangeSelector: {
              type,
              value,
            },
          });
        }}
      >
        {text}
      </button>
    );

    const selectors = [
      {
        key: "2weeks",
        text: t("bodyMeasurements.rangeSelector.twoWeeks"),
        value: 2,
        type: "weeks",
        active: !quickDisabled && type === "weeks" && value === 2,
      },
      {
        key: "1month",
        text: t("bodyMeasurements.rangeSelector.oneMonth"),
        value: 1,
        type: "months",
        active: !quickDisabled && type === "months" && value === 1,
      },
      {
        key: "3month",
        text: t("bodyMeasurements.rangeSelector.threeMonths"),
        value: 3,
        type: "months",
        active: !quickDisabled && type === "months" && value === 3,
      },
      {
        key: "6month",
        text: t("bodyMeasurements.rangeSelector.sixMonths"),
        value: 6,
        type: "months",
        active: !quickDisabled && type === "months" && value === 6,
      },
      {
        key: "lifetime",
        text: t("bodyMeasurements.rangeSelector.lifetime"),
        value: 1,
        type: "lifetime",
        active: !quickDisabled && type === "lifetime",
      },
    ];
    return (
      <div className="selector-container">
        {selectors.map((props) => (
          <Selector {...props} getDateFirstEntry={getDateFirstEntry} />
        ))}
      </div>
    );
  }

  handleDateChange(date, type = "dateFrom") {
    const { dateFrom, dateTo, updateState } = this.props;
    let arg = {
      [type]: date,
      quickDisabled: true,
    };

    if (type === "dateTo" && moment(date).isBefore(dateFrom || new Date())) {
      // If dateTo is before than dateFrom, update dateFrom
      arg = Object.assign({}, arg, {
        dateFrom: date,
      });
    }

    if (type === "dateFrom" && !dateTo) {
      arg = Object.assign({}, arg, {
        dateTo: moment(new Date()).format(dateFormat.calendar),
      });
    }

    updateState(arg);
  }

  render() {
    const {
      dateFrom,
      dateTo,
      reportSelected,
      unitSelected,
      unitOptions = [],
      updateState,
      comesFromBodyComp,
      locals,
      t,
    } = this.props;
    return (
      <header>
        <hgroup>
          <div
            className={
              comesFromBodyComp
                ? "mobile-hidden flex gap-2 items-center"
                : "mobile-hidden "
            }
          >
            {comesFromBodyComp ? (
              <SvgIcon
                classNames="cursor-pointer "
                onClickFn={() => {
                  history.back();
                }}
                src={"/img/new-icons/back-button.svg"}
              />
            ) : (
              <></>
            )}

            <h2 className="mobile-hidden">{reportSelected}</h2>
          </div>
          {["Bodyweight", "Body Measurements"].includes(reportSelected) ? (
            <ReportsBackHandler title={reportSelected} locals={locals} />
          ) : null}

          <ButtonSwitch
            options={unitOptions}
            selectedOption={unitOptions.find(
              (opt) => opt.unit === unitSelected
            )}
            size="small"
            onClickFn={(opt) => updateState({ unitSelected: opt.unit })}
          />
        </hgroup>
        <hgroup>
          <div role="calendar-date-selectors" className="mobile-hidden">
            <DateInput
              name="from"
              placeholder={t("bodyMeasurements.startDate")}
              value={dateFrom || new Date()}
              max={dateTo || new Date()}
              onChange={(date) => this.handleDateChange(date, "dateFrom")}
            />
            <span>{t("bodyMeasurements.to")}</span>
            <DateInput
              name="to"
              placeholder={t("bodyMeasurements.endDate")}
              value={dateTo || new Date()}
              max={new Date()}
              onChange={(date) => this.handleDateChange(date, "dateTo")}
            />
          </div>
          {this.renderRangeSelector()}
        </hgroup>
      </header>
    );
  }
}

RangeContainerComponent.contextType = RillContext;

export default withTranslation("athlete-portal")(RangeContainerComponent);
